'use memo';

import type { UiNode, UiNodeInputAttributes } from '@ory/client';
import { useState } from 'react';
import { FormItem } from '@/components/FormItem';
import { PasswordField } from '@/components/PasswordField';
import { useNodeTranslation } from '@/features/auth/hooks/useNodeTranslation';
import { DEFAULT_PASSWORD_POLICY } from '@/lib/api/orpc/contracts/auth-password';

/** 表示順序: 入力フィールドは中間に配置 */
export const ORDER = 50;
type Props = {
  node: UiNode;
  disabled?: boolean;
};

/**
 * Password inputノードコンポーネント
 *
 * Ory KratosのServer Driven UIで返されるpassword inputフィールドをレンダリングします。
 * autocomplete="new-password" の場合は共有 PasswordField のポリシーチェックリストを表示します。
 *
 * @see https://www.ory.com/docs/kratos/concepts/ui-user-interface#ui-input-nodes
 */
export function PasswordInput({
  node,
  disabled
}: Props) {
  const {
    translateUiText
  } = useNodeTranslation();
  const attrs = node.attributes as UiNodeInputAttributes;
  const shouldValidateStrength = attrs.autocomplete === 'new-password';
  const [value, setValue] = useState<string>(attrs.value as string || '');
  if (attrs.type !== 'password') {
    return null;
  }
  const label = node.meta?.label ? translateUiText(node.meta.label) : undefined;
  const serverErrorMessages = node.messages?.filter(msg => msg.type === 'error').map(msg => translateUiText(msg));

  // 強度チェックは PasswordField のチェックリストが担う。FormItem にはサーバエラーのみ出す。
  const displayErrorMessage = serverErrorMessages?.[0];
  const hasError = Boolean(serverErrorMessages?.length);
  return <FormItem fieldTitle={label} optional={!attrs.required} errorMessage={displayErrorMessage} className="w-full" fieldInput={<PasswordField name={attrs.name} value={value} onChange={setValue} placeholder={(attrs as {
    placeholder?: string;
  }).placeholder} disabled={disabled ?? attrs.disabled} required={attrs.required} autoComplete={attrs.autocomplete as string | undefined} policy={shouldValidateStrength ? DEFAULT_PASSWORD_POLICY : undefined} error={hasError} />} />;
}